import { OnInit, Component, Inject, Optional, ViewChild, ElementRef } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { Observable } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PershingTranslationService } from '@pershing/pershing-core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'citi-real-time-component',
    templateUrl: './citi-real-time-component.html'
})

export class CitiRealTimeComponent implements OnInit {
    @ViewChild('realtimeTransferForm') realtimeTransferForm: ElementRef;
    appSettings: any;
    corr: Observable<string>;
    officeNum: Observable<string>;
    clientIP: Observable<string>;
    siteId: Observable<string>;
    srcAcctId: Observable<string>;
    destAcctId: Observable<string>;
    bankAcctBal: Observable<string>;
    returnLandingURL: Observable<string>;
    productCode: Observable<string>;
    refreshURL: Observable<string>;

    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private location: Location,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                private route: ActivatedRoute,
                @Optional() @Inject('AppSettings') appSettings: any,
                private sanitizer: DomSanitizer) {
                    this.appSettings = appSettings;
                    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        // Call the wiget params service to get the valid args
        this.widgetsParamService();
    }

    ngAfterViewInit() {
        let detect = navigator.userAgent.toLowerCase();
        let isSafari = false;
        // Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
        let browser;
        if (detect.indexOf('msie') > 0 || detect.indexOf('trident') > 0) {
            browser = 'ie';
        } else {
            browser = 'other';
        }
        let nodes = document.getElementsByTagName('nav')[0];
        if (nodes) {
            if (browser === 'ie') {
                document.getElementsByTagName('nav')[0].style.display = 'none';
            } else if (isSafari) {
                nodes.innerHTML = ' ';
            } else {
                nodes.remove();
            }
        }
        document.getElementById('topNavRem').style.display = 'none';
    }

    widgetsParamService() {
        this.nxiWidgetParamsService.getWidgetParam('/commonrest/citirealtime').subscribe(
            resp => {
                if (resp.response) {
                    // this.corr =  this.appSettings.ibdConfigMap.IBD;
                    // this.officeNum = this.appSettings.ibdConfigMap.OFF;
                    // this.clientIP = resp.response.clientIP;
                    // this.siteId = resp.response.siteId;
                    // this.srcAcctId = resp.response.srcAcctId;
                    // this.destAcctId = resp.response.destAcctId;
                    // this.bankAcctBal = resp.response.bankAcctBal;
                    // this.returnLandingURL = resp.response.returnLandingURL;
                    // this.productCode = resp.response.productCode;
                    // this.refreshURL = resp.response.refreshURL;
                    let inputValue =  '<input type="hidden" name="Corr" id="Corr" value="' + this.appSettings.ibdConfigMap.IBD + '"/>' +
                    '<input type="hidden" name="OffNum" id="OffNum" value="' + this.appSettings.ibdConfigMap.OFF + '"/>' +
                    '<input type="hidden" name="ClientIP" id="ClientIP" value="' + resp.response.clientIP + '"/>' +
                    '<input type="hidden" name="siteId" id="siteId" value="' + resp.response.siteId + '"/>' +
                    '<input type="hidden" name="SrcAcctId" id="SrcAcctId" value="' + resp.response.srcAcctId + '"/>' +
                    '<input type="hidden" name="DestAcctId" id="DestAcctId" value="' + resp.response.destAcctId + '"/>' +
                    '<input type="hidden" name="BankAcctBal" id="BankAcctBal" value="' + resp.response.bankAcctBal + '"/>' +
                    '<input type="hidden" name="TransferHomeURL" id="TransferHomeURL" value="' + resp.response.returnLandingURL + '"/>' +
                    '<input type="hidden" name="cssURL" id="cssURL" value="https://onlineinvestments.citi.com/images/style_CBOL.css"/>' +
                    '<input type="hidden" name="productCode" id="productCode" value="' + resp.response.productCode + '"/>' +
                    '<input type="hidden" name="redirectWindow" id="redirectWindow" value="top"/>' +
                    '<input type="hidden" name="RefreshBalancesURL" id="RefreshBalancesURL" value="' + resp.response.refreshURL + '"/>';
                    this.realtimeTransferForm.nativeElement.innerHTML = inputValue;
                    this.realtimeTransferForm.nativeElement.submit();
                }
            }
        );
    }
}
